<div class="login-container">
  <div class="login-box">
    <div class="login-title">
      <h2 class="login-title-txt">Acesse suas compras</h2>
    </div>

    <form [formGroup]="form" (ngSubmit)="onLogin(form.value)">
      <div class="input-group">
        <mat-form-field appearance="outline">
            <mat-label>E-mail</mat-label>
            <input matInput formControlName="email">
            <mat-error *ngIf="isInvalid('email')">{{ mensagemDeErro('email') }}</mat-error>
        </mat-form-field>
      </div>
      <div class="input-group">
        <mat-form-field appearance="outline">
            <mat-label>CPF</mat-label>
            <input matInput type="tel" mask="000.000.000-00" formControlName="cpf">
            <mat-error *ngIf="isInvalid('cpf')">{{ mensagemDeErro('cpf') }}</mat-error>
        </mat-form-field>
      </div>
      
      <div class="button-group">
          <button class="login-button login-button-primary" type="submit" [disabled]="form.invalid">
            <span *ngIf="!isLoading()">Entrar</span>
            <span *ngIf="isLoading()" class="spinner"></span>
          </button>
        <button class="login-button login-button-secondary" [disabled]="isLoading()" [mat-dialog-close]="false">Cancelar</button>
      </div>
    </form>

  </div>
</div>